/**
 * Extract properties from an object that start with a specific prefix.
 * @param props - The object to extract properties from
 * @param type - The prefix to match property keys against
 * @returns An object containing only properties with keys that start with the specified prefix
 */
export function extractProps<T, E extends ExtractedProp>(props: Dictionary<string, any>, type: E): ExtractedProps<T, E>;

/**
 * Extract properties from an object that start with any of the specified prefixes.
 * @param props - The object to extract properties from
 * @param types - Array of prefixes to match property keys against
 * @returns An object containing only properties with keys that start with any of the specified prefixes
 */
export function extractProps<T, E extends ExtractedProp>(
    props: Dictionary<string, any>,
    types: E[],
): ExtractedProps<T, E>;

export function extractProps<T, E extends ExtractedProp>(
    props: Dictionary<string, any>,
    typeOrTypes: E | E[],
): ExtractedProps<T, E> {
    const types = Array.isArray(typeOrTypes) ? typeOrTypes : [typeOrTypes];
    return Object.keys(props).reduce((acc, key) => {
        if (types.some(type => key.startsWith(type))) {
            acc[key as keyof ExtractedProps<T, E>] = props[key];
        }
        return acc;
    }, {} as ExtractedProps<T, E>);
}
